import state from './app.state'
import mutations from './app.mutations'
import actions from './app.actions'

export default {
  state,
  mutations,
  actions
}
